import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Eye } from 'lucide-react';
import api from '@/utils/api';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageViews, setPageViews] = useState(null);

  useEffect(() => {
    // Increment page views on every page change
    const incrementAndFetch = async () => {
      try {
        const response = await api.post('/api/page-views/increment');
        setPageViews(response.data.total_views);
      } catch (error) {
        // Fallback: just fetch current count
        try {
          const res = await api.get('/api/page-views');
          setPageViews(res.data.total_views);
        } catch (e) {
          setPageViews(800); // Default fallback
        }
      }
    };
    
    incrementAndFetch();
  }, [location.pathname]);

  const formatNumber = (num) => {
    if (!num) return '...';
    return num.toLocaleString('pt-BR');
  };

  return (
    <>
      <footer className="bg-[#002FA7] text-white py-8 px-6 mt-auto">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-6">
            <div>
              <h3 className="font-bold mb-3">Quero Publicar</h3>
              <p className="text-sm text-white/80">Conectando pesquisadores com oportunidades de publicação</p>
            </div>
            <div>
              <h4 className="font-semibold mb-3">Institucional</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => navigate('/about')} className="text-white/80 hover:text-white">
                    Quem Somos
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate('/contact')} className="text-white/80 hover:text-white">
                    Fale Conosco
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate('/blog')} className="text-white/80 hover:text-white">
                    Blog
                  </button>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-3">Apoie</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => navigate('/donation')} className="text-white/80 hover:text-white">
                    Faça uma Doação
                  </button>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-3">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => navigate('/terms')} className="text-white/80 hover:text-white">
                    Termos de Uso
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate('/privacy')} className="text-white/80 hover:text-white">
                    Política de Privacidade
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            <div>
              <h4 className="font-semibold mb-3">Acesso</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => navigate('/dashboard')} className="text-white/80 hover:text-white">
                    Buscar Chamadas
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate('/auth')} className="text-white/80 hover:text-white">
                    Entrar / Cadastrar
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 pt-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm">© 2026 Quero Publicar. Todos os direitos reservados.</p>
              
              {/* Page Views Counter */}
              {pageViews && (
                <div className="flex items-center gap-2 text-white/70 text-sm">
                  <Eye className="h-4 w-4" />
                  <span>{formatNumber(pageViews)} visualizações</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
